const apiConfig = {
  loginBaseUrl: "http://10.255.135.171:9110/permission",
  baseUrl: "/permission",
  clientId: "",
  callbackUrl: ""
};
const configApi = (config) => {
  Object.assign(apiConfig, config);
};
const getConfig = () => {
  return apiConfig;
};
const mergeConfig = (...configs) => {
  return Object.assign({}, apiConfig, ...configs);
};
export { apiConfig, configApi, getConfig, mergeConfig };
